export * from './window-type-7.component';